import { clearDisplayMapCache } from './userService';
import { clearSettingsCache } from './settingsService';
import { invalidateJourneyCache } from './journeyService';
import { invalidateSubjectsListCache } from './subjectStatsService';
import { clearPhCache } from './monitoringDashboardService';
import { clearPageLoadCache } from '../hooks/usePageLoad';

const LOGOUT_LS_PREFIXES = ['sj_cls_', 'tamkeen_', 'tm_pre_', 'tm_pre_cls_', 'fav_cache_'];
const LOGOUT_LS_KEYS = [
  'fav_cache',
  'notif_read_ts',
  'last_tamkeen_session_ts',
  'sj_lastJourney',
];

export function clearAllCaches(): void {
  clearDisplayMapCache();
  clearSettingsCache();
  invalidateJourneyCache();
  invalidateSubjectsListCache();
  clearPhCache();
  clearPageLoadCache();

  for (const key of LOGOUT_LS_KEYS) {
    try { localStorage.removeItem(key); } catch { /* quota / security */ }
  }
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key && LOGOUT_LS_PREFIXES.some(p => key.startsWith(p))) {
      try { localStorage.removeItem(key); } catch { /* quota / security */ }
    }
  }

  try { sessionStorage.clear(); } catch { /* security */ }
}
